export default "__VITE_ASSET__CgNrpqse__"